/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */
/*eslint no-undef: 0*/
"use strict";

import modalArchivoController from "./archivo.modal.controller";
import modalArchivoTemplate from "./archivo.modal.html";


class ImportarComputosController {
  constructor(
    DataService,
    Util,
    Modal,
    NgTableParams,
    _,
    Message,
    Proyecto,
    Storage,
    apiUrlSiga,
    $http,
    Integracion,
    Computo
  ) {
    "ngInject";
    this.DataService = DataService;
    this.Util = Util;
    this.Modal = Modal;
    this.NgTableParams = NgTableParams;
    this._ = _;
    this.Message = Message; 
    this.Proyecto = Proyecto;
    this.apiUrlSiga = apiUrlSiga;
    this.$http = $http;
    this.user = Storage.getUser();
    this.Integracion = Integracion;
    this.Computo = Computo;
  }

  $onInit() {
    this.titulo = "PRUEBA COMPONENTE";
    this.archivo = "computos";
    this.tipo = "ods";
    this.i_nombre_file = "NOMBRE DEL ARCHIVO";
    this.rutaArchivoComputo =this.apiUrl +`items/csv/manuales?archivo=${this.archivo}&tipo=${this.tipo}`;
    //console.log('prueba console log',this.titulo);
    console.log("------------------------------------");
    console.log(this.titulo);
    console.log(this.apiUrl);
    console.log(this.rutaArchivoComputo);
    console.log("VALOR DE ITEM ==>" +JSON.stringify(this.item));
    console.log("SUPERVISION ==>" + this.idsupervision);
    console.log("USUARIO ==>" + JSON.stringify(this.user));
    console.log("ID_USUARIO ==>" + JSON.stringify(this.user.id_usuario));
    //console.log("USUARIO ==>" + Object.values(this.user));


  }
  subirArchivo() {
    console.log("---------------SUBIR ARCHIVO-----------------");
    console.log(this.inputArchivo);
    console.log(this.inputTexto);
  }
  importarComputos() {
    const confArchivo = {
      //formatos: 'csv, xlsx, ods', //types
      formatos: "ods", //types
      // tipos: '.csv,.xlsx,.ods', //mime-types
      tipos: ".ods", //mime-types
      cargarItems: true,
      mensajeInformacion:
        "Puede importar computos desde un <strong>archivo en formato .ods</strong>.",
    };
    this.mostrarModal(
      "Importar Computos",
      "fa-upload",
      confArchivo,
      modalArchivoTemplate,
      modalArchivoController,
      "Importar"
    ).result.then((documento) => {
      const computos = {
        tipo:'importaComputos',        
        data: this.item,
        base64: documento.base64,
        idsupervision:this.idsupervision,
        usuarioregistro:this.user.id_usuario
      };
      

     const dts=this.Integracion.importacionComputosMetricos(computos)
     dts.then(function successCallback(respuesta){
       return respuesta.data;
      //console.log(respuesta.data);
     })
     .then((dts)=>{ 
       console.log(dts);
       if(dts.length>0){
        this.Message.warning(dts,`Importacion Cómputos Metricos`,12000);
       }
       else {
        this.Message.success(`Se importo el archivo de forma correcta`,`Importacion Cómputos Metricos`);

       }
       
       
     })
     .then(()=>{
      //console.log(this.item.id_item);
      return this.getComputosItem(this.item.id_item,this.idsupervision);
      //this.getComputosItem(this.item.id_item,this.idsupervision);
     })
     .then((dts)=>{
       console.log('datos=====>'+ dts)
      this.computos=dts;
      this.actualizarResumen(this.item.id_item,dts,this.resumen);
     })
    

//NO BORRARRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR
      // const dts=this.Integracion.listaProyectos();
      // dts.then((data)=>{
      //   console.log(data.data);
      // },
      // (error)=>{
      //   console.log("Error de la peticiona" + error);
      // }      
      // );
    });
  }
  mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
    return this.Modal.show({
      template: template,
      controller: controller,
      data: data || {},
      title: titulo,
      icon: icon,
      size: size ? size : "md",
      labelOk: labelOk,
    });
  }
  getComputosItem(item,idsupervision) {
    console.log('ID_ITEM==>'+ item);
    console.log('ID SUPERVISION==>'+ idsupervision);
    return this.DataService.get(`computos_metricos?item=${item}&supervision=${idsupervision}`)
    .then(response => {      
      //this.computos = this.Computo.getListaOrdenadaComputos(response.datos.computos, this.item);
      return this.computos=response.datos.computos;
      //return response.datos.computos;
      
    });
  }
  actualizarResumen(item,computos,resumen) {
    this.resumen = this.Computo.getResumen(item, computos, resumen);
  }
}

export default ImportarComputosController;



// WEBPACK FOOTER //
// ./src/app/components/integracion-siga/importacion-computos/importacion-computos.controller.js